import TemplateView from '../../../../TemplateView'

export default class ChooseReportHeader extends TemplateView {
    constructor() {
        super()
    }

    templateHtml() {
        return "<div class='chooseReport_header'>" +
               "  <div class='chooseReport_title'><%-title%></div>" +
               "  <div class='reportDescription_closeButton'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            title: 'Reports Description',
        }
    }

    getCloseButtonEl() {
        return this.find('.reportDescription_closeButton')
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/ChooseReportHeader.js